import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Icon } from '../icon/icon.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { RowProps, ValueProps } from './detailsTable.types';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
`;

export const Row: StyledComponent<'div', RowProps> = styled.div<RowProps>`
  padding-left: 16px;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${({ $isOdd, $withNewValue }: RowProps): Color =>
    $isOdd
      ? Color.Gray100 
      : $withNewValue ? Color.Warning100 : Color.White};
  border-bottom: 1px solid ${Color.Gray300};

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    min-height: 77px;
  }
`;

export const Label: StyledComponent<'div'> = styled.div`
  width: 159px;
  color: ${Color.Gray500};
  padding: 19px 16px 19px 0;
  flex-shrink: 0;

  @media ${Breakpoint.Mobile} {
    margin-bottom: 8px;
  }
`;

export const ValueContainer: StyledComponent<'div'> = styled.div`
  color: ${Color.Black};
  padding-left: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 2;

  @media ${Breakpoint.Mobile} {
    padding: 0;
    width: 100%;
  }
  
  @media ${Breakpoint.SmallMobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Value: StyledComponent<'div', ValueProps> = styled.div<ValueProps>`
  display: flex;
  flex-wrap: wrap;
  padding: ${({ $withPadding }: ValueProps): string => $withPadding ? '3px 0 11px' : '0'};

  @media ${Breakpoint.Mobile} {
    padding: 0;
  }
`;

export const ImgLink: StyledComponent<'a'> = styled.a`
  width: fit-content;
  padding: 7px 12px;
  height: fit-content;
  border-radius: 50px;
  display: flex;
  align-items: center;
  border: 1px solid ${Color.Gray300};
  margin: 8px 4px 0 0;

  @media ${Breakpoint.Mobile} {
    margin: 0 4px 4px 0;
  }
`;

export const LinkContainer: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  padding: 7px 12px;
  background-color: ${Color.White};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  border: 1px solid ${Color.Gray300};
  margin: 8px 4px 0 0;
  font-weight: ${FontWeight.Regular};
  font-size: 14px;
  line-height: 18px;

  @media ${Breakpoint.Mobile} {
    margin: 0 4px 4px 0;
  }
`;

export const SimpleValue: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Gray500};
  margin-left: 4px;
  word-break: break-all;
`;

export const TextValue: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Black};
  margin: 19px 0;

  @media ${Breakpoint.Mobile} {
    margin: 0;
  }
`;

export const InfoContainer: StyledComponent<'div'> = styled.div`
  min-width: 200px;
  padding: 19px 16px;
  display: flex;
  justify-content: flex-end;

  @media ${Breakpoint.Mobile} {
    padding: 0;
  }

  @media ${Breakpoint.SmallMobile} {
    padding: 19px 0 0 0;
    justify-content: flex-start;
  }
`;

export const InfoLabel: StyledComponent<'p'> = styled.p`
  color: ${Color.Black};
  font-size: 14px;
  line-height: 18px;
  margin-right: 8px;
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  flex-shrink: 0;
`;
